import React, { useState, useEffect } from 'react';
import { Zap, ArrowRight } from 'lucide-react';
import { flashSale } from '../data/mock';
import { toast } from 'sonner';

const FlashSaleBanner = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(flashSale.endDate) - new Date();
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);

  const TimeBox = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div className="bg-white text-gray-800 font-bold text-xl sm:text-2xl px-3 py-2 rounded-lg shadow-md min-w-[50px] text-center">
        {String(value).padStart(2, '0')}
      </div>
      <span className="text-xs text-amber-100 mt-1 uppercase">{label}</span>
    </div>
  );

  return (
    <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 text-white">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Left - Flash Sale Info */}
          <div className="flex items-center gap-3">
            <div className="relative p-2 bg-white/20 rounded-full">
              <Zap className="w-6 h-6 animate-pulse" />
              <div className="absolute inset-0 bg-yellow-300 rounded-full blur-md opacity-30 animate-ping" />
            </div>
            <div>
              <h3 className="font-bold text-lg">{flashSale.title}</h3>
              <p className="text-amber-100 text-sm">{flashSale.subtitle}</p>
            </div>
          </div>

          {/* Center - Countdown */}
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium mr-2 hidden sm:inline">Ends in:</span>
            <div className="flex items-center gap-2">
              <TimeBox value={timeLeft.days} label="Days" />
              <span className="text-2xl font-bold">:</span>
              <TimeBox value={timeLeft.hours} label="Hrs" />
              <span className="text-2xl font-bold">:</span>
              <TimeBox value={timeLeft.minutes} label="Min" />
              <span className="text-2xl font-bold">:</span>
              <TimeBox value={timeLeft.seconds} label="Sec" />
            </div>
          </div>

          {/* Right - Shop Now Button */}
          <button
            onClick={() => {
              const flashSection = document.getElementById('flash-deals');
              if (flashSection) {
                flashSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              } else {
                // No active flash deals section — scroll to products and notify
                const productsSection = document.querySelector('[data-testid="product-grid"]') || document.querySelector('.product-grid');
                if (productsSection) {
                  productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                toast.info('Flash deals are coming soon! Browse our current offers below.');
              }
            }}
            className="flex items-center gap-2 px-6 py-2.5 bg-white text-orange-600 font-semibold rounded-full hover:bg-orange-50 hover:scale-105 transition-all shadow-lg"
            data-testid="flash-sale-shop-now"
          >
            Shop Now
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FlashSaleBanner;
